if (!Array.from) {
  Array.from = (function () {
    var toStr = Object.prototype.toString;
    var isCallable = function (fn) { 
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function (value) { 
      var number = Number(value); 
      if (isNaN(number)) { return 0; }
      if (number === 0 || !isFinite(number)) { return number; }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number)); 
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function (value) { 
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    }; 
  
    // La propriété length de la méthode vaut 1.
    return function from(arrayLike/*, mapFn, thisArg */) { 
      // 1. Soit C, la valeur this
      var C = this;
      
      // 2. Soit items le ToObject(arrayLike).
      var items = Object(arrayLike); 
      
      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) { 
        throw new TypeError("Array.from doit utiliser un objet semblable à un tableau - null ou undefined ne peuvent pas être utilisés");
      }
    
      // 4. Si mapfn est undefined, le mapping sera false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {  
        // 5. sinon      
        // 5. a. si IsCallable(mapfn) est false, on lève une TypeError.
        if (!isCallable(mapFn)) { 
          throw new TypeError('Array.from: lorsqu il est utilisé le deuxième argument doit être une fonction'); 
        }
     
        // 5. b. si thisArg a été fourni, T sera thisArg ; sinon T sera undefined.
        if (arguments.length > 2) { 
          T = arguments[2];
        }
      }
    
      // 10. Soit lenValue pour Get(items, "length").
      // 11. Soit len pour ToLength(lenValue).
      var len = toLength(items.length);  
     
      // 13. Si IsConstructor(C) vaut true, alors
      // 13. a. Soit A le résultat de l'appel à la méthode interne [[Construct]] avec une liste en argument qui contient l'élément len.
      // 14. a. Sinon, soit A le résultat de ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);
   
      // 16. Soit k égal à 0.
      var k = 0;  // 17. On répète tant que k < len… 
      var kValue;
      while (k < len) {
        kValue = items[k]; 
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k); 
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Soit putStatus égal à Put(A, "length", len, true).
      A.length = len;  // 20. On renvoie A.
      return A;
    };
  }());
}

export const days = Array.from({length: 31}, (v, k) => k + 1).map((v, i) => ({key: i, text: v, value: v}))
export const months = [
  { key: 'j', text: 'January', value: 0 },
  { key: 'f', text: 'February', value: 1 },
  { key: 'm', text: 'March', value: 2 },
  { key: 'a', text: 'April', value: 3 },
  { key: 'ma', text: 'May', value: 4 },
  { key: 'ju', text: 'June', value: 5 },
  { key: 'ji', text: 'July', value: 6 },
  { key: 'ao', text: 'August', value: 7 },
  { key: 's', text: 'September', value: 8 },
  { key: 'o', text: 'October', value: 9 },
  { key: 'n', text: 'November', value: 10 },
  { key: 'd', text: 'December', value: 11 }
];
export const monthsSmall = [
  { key: 'j', text: '01', value: 0 },
  { key: 'f', text: '02', value: 1 },
  { key: 'm', text: '03', value: 2 },
  { key: 'a', text: '04', value: 3 },
  { key: 'ma', text: '05', value: 4 },
  { key: 'ju', text: '06', value: 5 },
  { key: 'ji', text: '07', value: 6 },
  { key: 'ao', text: '08', value: 7 },
  { key: 's', text: '09', value: 8 },
  { key: 'o', text: '10', value: 9 },
  { key: 'n', text: '11', value: 10 },
  { key: 'd', text: '12', value: 11 }
];
export const years = Array.from({length: 100}, (v, k) => k + 1918).map((v, i) => ({key: i, text: v, value: v}))

export const sexes = [
  { key: 'm', text: 'MALE', value: 'MALE' },
  { key: 'f', text: 'FEMALE', value: 'FEMALE' },
]

export const euroCountries = [
  'de-AT', // Austria
  'de-DE', // Germany
  'de-LU', // Luxembourg
  'nl-BE', // Belgium
  'fr-BE', // Belgium FR
  'el',    // Greece
  'el-EL',
  'el-CY', // Cyprus
  'et', // Estonia
  'et-ET',
  'sv-FI', // Finland
  'fr',
  'fr-FR', // France
  'en-IE', // Ireland
  'it',
  'it-IT', // Italia
  'lt', // Lithuania
  'lt-LT',
  'lv', // Latvia
  'lv-LV',
  'mt', // Malta
  'mt-MT',
  'en-MT',
  'nl-NL', // Netherlands
  'pt-PT', // Portugal
  'es-ES', // Spain
  'ca-ES', // Catalan
  'sl', // Slovenia
  'sl-SL',
  'sk',
  'sk-SK' // Slovakia
]

export const countries = [
  {
    key: 0,
    text: 'Afghanistan',
    value: 0,
  }, {
    key: 1,
    text: 'Åland Islands',
    value: 1,
  }, {
    key: 2,
    text: 'Albania',
    value: 2,
  }, {
    key: 3,
    text: 'Algeria',
    value: 3,
  }, {
    key: 4,
    text: 'American Samoa',
    value: 4,
  }, {
    key: 5,
    text: 'Andorra',
    value: 5,
  }, {
    key: 6,
    text: 'Angola',
    value: 6,
  }, {
    key: 7,
    text: 'Anguilla',
    value: 7,
  }, {
    key: 8,
    text: 'Antarctica',
    value: 8,
  }, {
    key: 9,
    text: 'Antigua and Barbuda',
    value: 9,
  }, {
    key: 10,
    text: 'Argentina',
    value: 10,
  }, {
    key: 11,
    text: 'Armenia',
    value: 11,
  }, {
    key: 12,
    text: 'Aruba',
    value: 12,
  }, {
    key: 13,
    text: 'Australia',
    value: 13,
  }, {
    key: 14,
    text: 'Austria',
    value: 14,
  }, {
    key: 15,
    text: 'Azerbaijan',
    value: 15,
  }, {
    key: 16,
    text: 'Bahamas',
    value: 16,
  }, {
    key: 17,
    text: 'Bahrain',
    value: 17,
  }, {
    key: 18,
    text: 'Bangladesh',
    value: 18,
  }, {
    key: 19,
    text: 'Barbados',
    value: 19,
  }, {
    key: 20,
    text: 'Belarus',
    value: 20,
  }, {
    key: 21,
    text: 'Belgium',
    value: 21,
  }, {
    key: 22,
    text: 'Belize',
    value: 22,
  }, {
    key: 23,
    text: 'Benin',
    value: 23,
  }, {
    key: 24,
    text: 'Bermuda',
    value: 24,
  }, {
    key: 25,
    text: 'Bhutan',
    value: 25,
  }, {
    key: 26,
    text: 'Bolivia (Plurinational State of)',
    value: 26,
  }, {
    key: 27,
    text: 'Bonaire, Sint Eustatius and Saba',
    value: 27,
  }, {
    key: 28,
    text: 'Bosnia and Herzegovina',
    value: 28,
  }, {
    key: 29,
    text: 'Botswana',
    value: 29,
  }, {
    key: 30,
    text: 'Bouvet Island',
    value: 30,
  }, {
    key: 31,
    text: 'Brazil',
    value: 31,
  }, {
    key: 32,
    text: 'British Indian Ocean Territory',
    value: 32,
  }, {
    key: 33,
    text: 'United States Minor Outlying Islands',
    value: 33,
  }, {
    key: 34,
    text: 'Virgin Islands (British)',
    value: 34,
  }, {
    key: 35,
    text: 'Virgin Islands (U.S.)',
    value: 35,
  }, {
    key: 36,
    text: 'Brunei Darussalam',
    value: 36,
  }, {
    key: 37,
    text: 'Bulgaria',
    value: 37,
  }, {
    key: 38,
    text: 'Burkina Faso',
    value: 38,
  }, {
    key: 39,
    text: 'Burundi',
    value: 39,
  }, {
    key: 40,
    text: 'Cambodia',
    value: 40,
  }, {
    key: 41,
    text: 'Cameroon',
    value: 41,
  }, {
    key: 42,
    text: 'Canada',
    value: 42,
  }, {
    key: 43,
    text: 'Cabo Verde',
    value: 43,
  }, {
    key: 44,
    text: 'Cayman Islands',
    value: 44,
  }, {
    key: 45,
    text: 'Central African Republic',
    value: 45,
  }, {
    key: 46,
    text: 'Chad',
    value: 46,
  }, {
    key: 47,
    text: 'Chile',
    value: 47,
  }, {
    key: 48,
    text: 'China',
    value: 48,
  }, {
    key: 49,
    text: 'Christmas Island',
    value: 49,
  }, {
    key: 50,
    text: 'Cocos (Keeling) Islands',
    value: 50,
  }, {
    key: 51,
    text: 'Colombia',
    value: 51,
  }, {
    key: 52,
    text: 'Comoros',
    value: 52,
  }, {
    key: 53,
    text: 'Congo',
    value: 53,
  }, {
    key: 54,
    text: 'Congo (Democratic Republic of the)',
    value: 54,
  }, {
    key: 55,
    text: 'Cook Islands',
    value: 55,
  }, {
    key: 56,
    text: 'Costa Rica',
    value: 56,
  }, {
    key: 57,
    text: 'Croatia',
    value: 57,
  }, {
    key: 58,
    text: 'Cuba',
    value: 58,
  }, {
    key: 59,
    text: 'Curaçao',
    value: 59,
  }, {
    key: 60,
    text: 'Cyprus',
    value: 60,
  }, {
    key: 61,
    text: 'Czech Republic',
    value: 61,
  }, {
    key: 62,
    text: 'Denmark',
    value: 62,
  }, {
    key: 63,
    text: 'Djibouti',
    value: 63,
  }, {
    key: 64,
    text: 'Dominica',
    value: 64,
  }, {
    key: 65,
    text: 'Dominican Republic',
    value: 65,
  }, {
    key: 66,
    text: 'Ecuador',
    value: 66,
  }, {
    key: 67,
    text: 'Egypt',
    value: 67,
  }, {
    key: 68,
    text: 'El Salvador',
    value: 68,
  }, {
    key: 69,
    text: 'Equatorial Guinea',
    value: 69,
  }, {
    key: 70,
    text: 'Eritrea',
    value: 70,
  }, {
    key: 71,
    text: 'Estonia',
    value: 71,
  }, {
    key: 72,
    text: 'Ethiopia',
    value: 72,
  }, {
    key: 73,
    text: 'Falkland Islands (Malvinas)',
    value: 73,
  }, {
    key: 74,
    text: 'Faroe Islands',
    value: 74,
  }, {
    key: 75,
    text: 'Fiji',
    value: 75,
  }, {
    key: 76,
    text: 'Finland',
    value: 76,
  }, {
    key: 77,
    text: 'France',
    value: 77,
  }, {
    key: 78,
    text: 'French Guiana',
    value: 78,
  }, {
    key: 79,
    text: 'French Polynesia',
    value: 79,
  }, {
    key: 80,
    text: 'French Southern Territories',
    value: 80,
  }, {
    key: 81,
    text: 'Gabon',
    value: 81,
  }, {
    key: 82,
    text: 'Gambia',
    value: 82,
  }, {
    key: 83,
    text: 'Georgia',
    value: 83,
  }, {
    key: 84,
    text: 'Germany',
    value: 84,
  }, {
    key: 85,
    text: 'Ghana',
    value: 85,
  }, {
    key: 86,
    text: 'Gibraltar',
    value: 86,
  }, {
    key: 87,
    text: 'Greece',
    value: 87,
  }, {
    key: 88,
    text: 'Greenland',
    value: 88,
  }, {
    key: 89,
    text: 'Grenada',
    value: 89,
  }, {
    key: 90,
    text: 'Guadeloupe',
    value: 90,
  }, {
    key: 91,
    text: 'Guam',
    value: 91,
  }, {
    key: 92,
    text: 'Guatemala',
    value: 92,
  }, {
    key: 93,
    text: 'Guernsey',
    value: 93,
  }, {
    key: 94,
    text: 'Guinea',
    value: 94,
  }, {
    key: 95,
    text: 'Guinea-Bissau',
    value: 95,
  }, {
    key: 96,
    text: 'Guyana',
    value: 96,
  }, {
    key: 97,
    text: 'Haiti',
    value: 97,
  }, {
    key: 98,
    text: 'Heard Island and McDonald Islands',
    value: 98,
  }, {
    key: 99,
    text: 'Holy See',
    value: 99,
  }, {
    key: 100,
    text: 'Honduras',
    value: 100,
  }, {
    key: 101,
    text: 'Hong Kong',
    value: 101,
  }, {
    key: 102,
    text: 'Hungary',
    value: 102,
  }, {
    key: 103,
    text: 'Iceland',
    value: 103,
  }, {
    key: 104,
    text: 'India',
    value: 104,
  }, {
    key: 105,
    text: 'Indonesia',
    value: 105,
  }, {
    key: 106,
    text: 'Côte d\'Ivoire',
    value: 106,
  }, {
    key: 107,
    text: 'Iran (Islamic Republic of)',
    value: 107,
  }, {
    key: 108,
    text: 'Iraq',
    value: 108,
  }, {
    key: 109,
    text: 'Ireland',
    value: 109,
  }, {
    key: 110,
    text: 'Isle of Man',
    value: 110,
  }, {
    key: 111,
    text: 'Israel',
    value: 111,
  }, {
    key: 112,
    text: 'Italy',
    value: 112,
  }, {
    key: 113,
    text: 'Jamaica',
    value: 113,
  }, {
    key: 114,
    text: 'Japan',
    value: 114,
  }, {
    key: 115,
    text: 'Jersey',
    value: 115,
  }, {
    key: 116,
    text: 'Jordan',
    value: 116,
  }, {
    key: 117,
    text: 'Kazakhstan',
    value: 117,
  }, {
    key: 118,
    text: 'Kenya',
    value: 118,
  }, {
    key: 119,
    text: 'Kiribati',
    value: 119,
  }, {
    key: 120,
    text: 'Kuwait',
    value: 120,
  }, {
    key: 121,
    text: 'Kyrgyzstan',
    value: 121,
  }, {
    key: 122,
    text: 'Lao People\'s Democratic Republic',
    value: 122,
  }, {
    key: 123,
    text: 'Latvia',
    value: 123,
  }, {
    key: 124,
    text: 'Lebanon',
    value: 124,
  }, {
    key: 125,
    text: 'Lesotho',
    value: 125,
  }, {
    key: 126,
    text: 'Liberia',
    value: 126,
  }, {
    key: 127,
    text: 'Libya',
    value: 127,
  }, {
    key: 128,
    text: 'Liechtenstein',
    value: 128,
  }, {
    key: 129,
    text: 'Lithuania',
    value: 129,
  }, {
    key: 130,
    text: 'Luxembourg',
    value: 130,
  }, {
    key: 131,
    text: 'Macao',
    value: 131,
  }, {
    key: 132,
    text: 'Macedonia (the former Yugoslav Republic of)',
    value: 132,
  }, {
    key: 133,
    text: 'Madagascar',
    value: 133,
  }, {
    key: 134,
    text: 'Malawi',
    value: 134,
  }, {
    key: 135,
    text: 'Malaysia',
    value: 135,
  }, {
    key: 136,
    text: 'Maldives',
    value: 136,
  }, {
    key: 137,
    text: 'Mali',
    value: 137,
  }, {
    key: 138,
    text: 'Malta',
    value: 138,
  }, {
    key: 139,
    text: 'Marshall Islands',
    value: 139,
  }, {
    key: 140,
    text: 'Martinique',
    value: 140,
  }, {
    key: 141,
    text: 'Mauritania',
    value: 141,
  }, {
    key: 142,
    text: 'Mauritius',
    value: 142,
  }, {
    key: 143,
    text: 'Mayotte',
    value: 143,
  }, {
    key: 144,
    text: 'Mexico',
    value: 144,
  }, {
    key: 145,
    text: 'Micronesia (Federated States of)',
    value: 145,
  }, {
    key: 146,
    text: 'Moldova (Republic of)',
    value: 146,
  }, {
    key: 147,
    text: 'Monaco',
    value: 147,
  }, {
    key: 148,
    text: 'Mongolia',
    value: 148,
  }, {
    key: 149,
    text: 'Montenegro',
    value: 149,
  }, {
    key: 150,
    text: 'Montserrat',
    value: 150,
  }, {
    key: 151,
    text: 'Morocco',
    value: 151,
  }, {
    key: 152,
    text: 'Mozambique',
    value: 152,
  }, {
    key: 153,
    text: 'Myanmar',
    value: 153,
  }, {
    key: 154,
    text: 'Namibia',
    value: 154,
  }, {
    key: 155,
    text: 'Nauru',
    value: 155,
  }, {
    key: 156,
    text: 'Nepal',
    value: 156,
  }, {
    key: 157,
    text: 'Netherlands',
    value: 157,
  }, {
    key: 158,
    text: 'New Caledonia',
    value: 158,
  }, {
    key: 159,
    text: 'New Zealand',
    value: 159,
  }, {
    key: 160,
    text: 'Nicaragua',
    value: 160,
  }, {
    key: 161,
    text: 'Niger',
    value: 161,
  }, {
    key: 162,
    text: 'Nigeria',
    value: 162,
  }, {
    key: 163,
    text: 'Niue',
    value: 163,
  }, {
    key: 164,
    text: 'Norfolk Island',
    value: 164,
  }, {
    key: 165,
    text: 'Korea (Democratic People\'s Republic of)',
    value: 165,
  }, {
    key: 166,
    text: 'Northern Mariana Islands',
    value: 166,
  }, {
    key: 167,
    text: 'Norway',
    value: 167,
  }, {
    key: 168,
    text: 'Oman',
    value: 168,
  }, {
    key: 169,
    text: 'Pakistan',
    value: 169,
  }, {
    key: 170,
    text: 'Palau',
    value: 170,
  }, {
    key: 171,
    text: 'Palestine, State of',
    value: 171,
  }, {
    key: 172,
    text: 'Panama',
    value: 172,
  }, {
    key: 173,
    text: 'Papua New Guinea',
    value: 173,
  }, {
    key: 174,
    text: 'Paraguay',
    value: 174,
  }, {
    key: 175,
    text: 'Peru',
    value: 175,
  }, {
    key: 176,
    text: 'Philippines',
    value: 176,
  }, {
    key: 177,
    text: 'Pitcairn',
    value: 177,
  }, {
    key: 178,
    text: 'Poland',
    value: 178,
  }, {
    key: 179,
    text: 'Portugal',
    value: 179,
  }, {
    key: 180,
    text: 'Puerto Rico',
    value: 180,
  }, {
    key: 181,
    text: 'Qatar',
    value: 181,
  }, {
    key: 182,
    text: 'Republic of Kosovo',
    value: 182,
  }, {
    key: 183,
    text: 'Réunion',
    value: 183,
  }, {
    key: 184,
    text: 'Romania',
    value: 184,
  }, {
    key: 185,
    text: 'Russian Federation',
    value: 185,
  }, {
    key: 186,
    text: 'Rwanda',
    value: 186,
  }, {
    key: 187,
    text: 'Saint Barthélemy',
    value: 187,
  }, {
    key: 188,
    text: 'Saint Helena, Ascension and Tristan da Cunha',
    value: 188,
  }, {
    key: 189,
    text: 'Saint Kitts and Nevis',
    value: 189,
  }, {
    key: 190,
    text: 'Saint Lucia',
    value: 190,
  }, {
    key: 191,
    text: 'Saint Martin (French part)',
    value: 191,
  }, {
    key: 192,
    text: 'Saint Pierre and Miquelon',
    value: 192,
  }, {
    key: 193,
    text: 'Saint Vincent and the Grenadines',
    value: 193,
  }, {
    key: 194,
    text: 'Samoa',
    value: 194,
  }, {
    key: 195,
    text: 'San Marino',
    value: 195,
  }, {
    key: 196,
    text: 'Sao Tome and Principe',
    value: 196,
  }, {
    key: 197,
    text: 'Saudi Arabia',
    value: 197,
  }, {
    key: 198,
    text: 'Senegal',
    value: 198,
  }, {
    key: 199,
    text: 'Serbia',
    value: 199,
  }, {
    key: 200,
    text: 'Seychelles',
    value: 200,
  }, {
    key: 201,
    text: 'Sierra Leone',
    value: 201,
  }, {
    key: 202,
    text: 'Singapore',
    value: 202,
  }, {
    key: 203,
    text: 'Sint Maarten (Dutch part)',
    value: 203,
  }, {
    key: 204,
    text: 'Slovakia',
    value: 204,
  }, {
    key: 205,
    text: 'Slovenia',
    value: 205,
  }, {
    key: 206,
    text: 'Solomon Islands',
    value: 206,
  }, {
    key: 207,
    text: 'Somalia',
    value: 207,
  }, {
    key: 208,
    text: 'South Africa',
    value: 208,
  }, {
    key: 209,
    text: 'South Georgia and the South Sandwich Islands',
    value: 209,
  }, {
    key: 210,
    text: 'Korea (Republic of)',
    value: 210,
  }, {
    key: 211,
    text: 'South Sudan',
    value: 211,
  }, {
    key: 212,
    text: 'Spain',
    value: 212,
  }, {
    key: 213,
    text: 'Sri Lanka',
    value: 213,
  }, {
    key: 214,
    text: 'Sudan',
    value: 214,
  }, {
    key: 215,
    text: 'Suriname',
    value: 215,
  }, {
    key: 216,
    text: 'Svalbard and Jan Mayen',
    value: 216,
  }, {
    key: 217,
    text: 'Swaziland',
    value: 217,
  }, {
    key: 218,
    text: 'Sweden',
    value: 218,
  }, {
    key: 219,
    text: 'Switzerland',
    value: 219,
  }, {
    key: 220,
    text: 'Syrian Arab Republic',
    value: 220,
  }, {
    key: 221,
    text: 'Taiwan, Province of China',
    value: 221,
  }, {
    key: 222,
    text: 'Tajikistan',
    value: 222,
  }, {
    key: 223,
    text: 'Tanzania, United Republic of',
    value: 223,
  }, {
    key: 224,
    text: 'Thailand',
    value: 224,
  }, {
    key: 225,
    text: 'Timor-Leste',
    value: 225,
  }, {
    key: 226,
    text: 'Togo',
    value: 226,
  }, {
    key: 227,
    text: 'Tokelau',
    value: 227,
  }, {
    key: 228,
    text: 'Tonga',
    value: 228,
  }, {
    key: 229,
    text: 'Trinidad and Tobago',
    value: 229,
  }, {
    key: 230,
    text: 'Tunisia',
    value: 230,
  }, {
    key: 231,
    text: 'Turkey',
    value: 231,
  }, {
    key: 232,
    text: 'Turkmenistan',
    value: 232,
  }, {
    key: 233,
    text: 'Turks and Caicos Islands',
    value: 233,
  }, {
    key: 234,
    text: 'Tuvalu',
    value: 234,
  }, {
    key: 235,
    text: 'Uganda',
    value: 235,
  }, {
    key: 236,
    text: 'Ukraine',
    value: 236,
  }, {
    key: 237,
    text: 'United Arab Emirates',
    value: 237,
  }, {
    key: 238,
    text: 'United Kingdom of Great Britain and Northern Ireland',
    value: 238,
  }, {
    key: 239,
    text: 'United States of America',
    value: 239,
  }, {
    key: 240,
    text: 'Uruguay',
    value: 240,
  }, {
    key: 241,
    text: 'Uzbekistan',
    value: 241,
  }, {
    key: 242,
    text: 'Vanuatu',
    value: 242,
  }, {
    key: 243,
    text: 'Venezuela (Bolivarian Republic of)',
    value: 243,
  }, {
    key: 244,
    text: 'Viet Nam',
    value: 244,
  }, {
    key: 245,
    text: 'Wallis and Futuna',
    value: 245,
  }, {
    key: 246,
    text: 'Western Sahara',
    value: 246,
  }, {
    key: 247,
    text: 'Yemen',
    value: 247,
  }, {
    key: 248,
    text: 'Zambia',
    value: 248,
  }, {
    key: 249,
    text: 'Zimbabwe',
    value: 249,
  }
]



// WEBPACK FOOTER //
// ./src/constants.js